import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["toast","error"] */ "/app/node_modules/react-toastify/dist/react-toastify.esm.mjs");
